webpackJsonp([176236309070072],{

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LocationGridItem = __webpack_require__(193);
	
	var _LocationGridItem2 = _interopRequireDefault(_LocationGridItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Get react/gatsby components
	
	
	var LocationGrid = function (_React$Component) {
	  _inherits(LocationGrid, _React$Component);
	
	  function LocationGrid() {
	    _classCallCheck(this, LocationGrid);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  LocationGrid.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'article',
	        { className: 'pfb-location-grid-container' },
	        _react2.default.createElement(
	          'section',
	          { className: 'pfb-location-grid-row' },
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Arizona', path: '/arizona', id: '1' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Albany, NY', path: '/albany', id: '7' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Park City, UT', path: '/park-city', id: '11' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Huntsville, AL', path: '/huntsville', id: '17' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Detroit, MI', path: '/detroit', id: '10' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Charlotte, NC', path: '/charlotte', id: '16' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Montana', path: '/montana', id: '1' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Washington, DC', path: '/washington-dc', id: '12' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Wisconsin', path: '/wisconsin', id: '6' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Port Angeles, WA', path: '/port-angeles', id: '18' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Las Vegas, NV', path: '/las-vegas', id: '19' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Chicago, IL', path: '/chicago', id: '8' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Colorado', path: '/colorado', id: '3' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Providence, RI', path: '/providence', id: '20' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'California', path: '/california', id: '21' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Columbus, OH', path: '/columbus', id: '2' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Portland, OR', path: '/portland', id: '5' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Texas', path: '/texas', id: '15' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Memphis, TN', path: '/memphis', id: '13' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Iowa', path: '/iowa', id: '22' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Arlington, VA', path: '/arlington', id: '14' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'St. Pete Beach, FL', path: '/st-pete-beach', id: '4' }),
	          _react2.default.createElement(_LocationGridItem2.default, { location: 'Wichita, KS', path: '/wichita', id: '23' })
	        )
	      )
	    );
	  };
	
	  return LocationGrid;
	}(_react2.default.Component);
	
	exports.default = LocationGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocationGridItem = function (_React$Component) {
	  _inherits(LocationGridItem, _React$Component);
	
	  function LocationGridItem() {
	    _classCallCheck(this, LocationGridItem);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  // descriptionHQ sends the 'colorado' location a special text block
	  LocationGridItem.prototype.descriptionHQ = function descriptionHQ() {
	    if (this.props.path === '/colorado') {
	      return _react2.default.createElement(
	        'div',
	        { className: 'pfb-grid-item-desc' },
	        'People for Bikes Headquarters'
	      );
	    }
	  };
	
	  LocationGridItem.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'grid-fade-in' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: this.props.path },
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement(
	            'h2',
	            { className: 'pfb-location-grid-title', id: this.props.id },
	            this.props.location
	          ),
	          this.descriptionHQ()
	        )
	      )
	    );
	  };
	
	  return LocationGridItem;
	}(_react2.default.Component);
	
	exports.default = LocationGridItem;
	module.exports = exports['default'];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LocationGrid = __webpack_require__(192);
	
	var _LocationGrid2 = _interopRequireDefault(_LocationGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Locations = function Locations() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_LocationGrid2.default, null)
	  );
	};
	
	exports.default = Locations;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-locations-js-944cf94fecb8f2f5f201.js